import Moralis from 'moralis';
import React from 'react';

export interface IMoralisContext {
  moralis: Moralis;
  initialized: boolean;
}

const defaultContext: IMoralisContext = {
  moralis: Moralis,
  initialized: false,
};
export const MoralisContext: React.Context<IMoralisContext> =
  React.createContext(defaultContext);
